import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=2221943b&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=js&"
export * from "./Choice.vue?vue&type=script&lang=js&"
import style0 from "./Choice.vue?vue&type=style&index=0&id=2221943b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221943b",
  null
  
)

export default component.exports